import axiosConfig from '../axiosConfig';

export interface LoginResponse {
	message: string;
	pinnedDashboardId?: string;
	mfa_token?: string;
	mfa_required?: boolean;
	hashed?: string;
	expire?: number;
}
export async function Login(username: string, password: string): Promise<LoginResponse> {
	return axiosConfig.instance.post('/app/login', { username, password }).then((response) => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const data = response.data;
		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		if (response.status === 202 && data?.mfa_token) {
			return {
				message: 'MFA required.',
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				mfa_token: data.mfa_token as string,
				mfa_required: true,
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				hashed: data.hashed as string,
				// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
				expire: data.expire as number,
			};
		}

		return {
			message: 'Successfully logged in.',
			pinnedDashboardId: data as string,
		};
	});
}

export async function LoginMFA(mfaToken: string, otp: string): Promise<LoginResponse> {
	return axiosConfig.instance
		.post('/app/verify-mfa', { mfa_token: mfaToken, otp })
		.then((response) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			return { message: 'Successfully logged in.', pinnedDashboardId: response.data };
		});
}

export async function ResendMFA(mfaToken: string): Promise<void> {
	return axiosConfig.instance.post('/app/resend-mfa', { mfa_token: mfaToken }).then(() => {
		return;
	});
}

export async function Logout(): Promise<LoginResponse> {
	return axiosConfig.instance.post('/logout').then(() => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		return { message: 'Successfully logged out.' };
	});
}

export async function Refresh(): Promise<LoginResponse> {
	return axiosConfig.instance.post('/app/refresh-session').then(() => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		return { message: 'Successfully refreshed the session.' };
	});
}

export async function SSOLogin(): Promise<any> {
	return axiosConfig.instance.post('/app/saml/signonservice').then((response) => {
		return response.data as string;
	});
}

export async function SSOLogout(): Promise<any> {
	return axiosConfig.instance.post('/app/saml/signoutservice').then((response) => {
		return response.data as string;
	});
}
export async function SSOMetadata(): Promise<any> {
	return axiosConfig.instance.get('/app/saml/sp_metadata').then((response) => {
		return response.data as string;
	});
}
